
const imageUrl = (title) => {
  return `/imgs/epld/${title}.png`;
};

const banner = {
  title: '物流控制塔（EPLD）',
  description: '物流控制塔（EPLD）是跨组织、端到端的供应链管控平台，以供应链控制塔为核心，提供从采销订单到物流计划优化再到海陆空铁物流执行的全链全渠道一体化解决方案，打造供应链协同能力，帮助客户实现供应链全程透明化、管理精细化。',
  img: imageUrl('banner')
};

const value = [
  {
    title: '多方云化协同，降本增效',
    items: [
      '以协同为主线，客户、内部运营、供应商和现场等多方协同作业。',
      '通过标准接口，链接供应商、海关、客户，作业标准化提高效率。',
      '使用电子合同，提高合同签订的效率，降低合同邮寄的成本。'
    ]
  },
  {
    title: '多类订单管理，构架业务控制中心',
    items: [
      '支持综合及单一的多种订单管理。',
      '以过程管控为导向的订单管理，支持全流程的订单可视化。',
      '支持工作任务的统一调度。',
      '异常的事中管理和事后追责赔付，对接应付进行记账。'
    ]
  },
  {
    title: '利用IT技术和标准化，提升自动化水平',
    items: [
      '利用GPS、北斗、电子围栏技术，实现车辆作业信息的自动化采集。',
      '通过规则配置，实现订单到运营方案到计费的自动化。',
      '通过配置调度规则，实现任务调度的自动化。',
      '根据计费规则和作业量自动生成费用。'
    ]
  },
  {
    title: '业财一体化，提高财务准确性和及时性',
    items: [
      '背靠背管理收付费用，规避少收多付，漏收漏付，规避运营风险。',
      '管理计费、对账、收付款各环节，杜绝漏收漏付、逾期收付。',
      '统一收付集中管控，全公司财务一盘棋。'
    ]
  },
  {
    title: '平台化的架构设计，业务拓展灵活',
    items: [
      '领先的业务和技术架构，满足拓展供应链平台的增值服务。',
      '持续拓展平台业务，打造供应链生态，为供应链赋能。'
    ]
  },
  {
    title: '标准接口体系，外部系统对接便捷',
    items: [
      '提供标准、稳定接口，减少对接时间和成本。',
      '链接上下游的伙伴，创造更多商业机会。',
      '通过实际业务场景，持续不断丰富标准接口。'
    ]
  },
];

const func = [
  {
    title: '订单管理',
    img: imageUrl('func1'),
    items: [
      '支持手动、Excel模板导入、第三方系统对接',
      '支持订单的自动拆分'
    ]
  },
  {
    title: '智能调度',
    img: imageUrl('func2'),
    items: [
      '可以灵活配置调度规则',
      '根据规则自动分配作业任务给相应的资源'
    ]
  },
  {
    title: '订单追踪',
    img: imageUrl('func3'),
    items: [
      '订单可视化',
      '订单项下作业任务可视化',
      '支持电子回单（ePLD）管理'
    ]
  },
  {
    title: '异常管理',
    img: imageUrl('func4'),
    items: [
      '支持异常事件接收和处理指令下达',
      '根据异常责任界定结果，生成相应的赔付费用，纳入应付账单'
    ]
  },
  {
    title: '合同管理',
    img: imageUrl('func5'),
    items: [
      '管理各类资源的合同的要点',
      '管理各类资源的合同价'
    ]
  },
  {
    title: '计费管理',
    img: imageUrl('func6'),
    items: [
      '根据计费方案自动生成各类应收应付,支持价税分离',
      '支持公司、合同、费用项三个级别的价税率管理'
    ]
  },
  {
    title: '协同门户',
    img: imageUrl('func7'),
    items: [
      '通过客户协同，实现客户订单、计费、账单和异常的在线协同',
      '通过供应商协同，实现接单、调度、计费、账单和异常的在线协同'
    ]
  },
  {
    title: '结算管理',
    img: imageUrl('func8'),
    items: [
      '应收应付的对账单，可以按模板生成账单',
      '支持出纳功能，对来往发票管理，并对收付款进行核销管理',
      '支持常用的财务报表',
      '与财务总账对接'
    ]
  },
];

const structure = imageUrl('structure');

export {banner, value, func, structure};


// WEBPACK FOOTER //
// ./src/routes/ProductEPLD/config.js